export const showElementWithoutImplementation: boolean =
  import.meta.env.VITE_SHOW_ELEMENT_WITHOUT_IMPLEMENTATION === "true";
